import type { Site } from '~/types/storeTypes'
import type { ILocales } from '~/types/localeTypes'

export default (site: Partial<Site>) => {
  const locales: ILocales = {}

  site?.languages?.forEach((lang) => {
    const localeIso = lang.iso_code.toLowerCase()

    locales[localeIso] = {
      id: lang.id,
      iso: localeIso,
      name: lang.local_title,
    }
  })

  return locales
}
